(() => {
  if (customElements.get('wiepa-richtext-properties')) return;

  // Ältere Importe speichern Zeilenumbrüche teilweise als ausgeschriebenes \\n.
  const normalizeBreaks = (value) => value.replace(/\\r\\n|\\n|\\r/g, '\n');

  function readRows(text) {
    let candidate = text.trim();
    for (let attempt = 0; attempt < 3; attempt += 1) {
      try {
        const parsed = JSON.parse(candidate);
        if (typeof parsed === 'string') {
          candidate = parsed;
          continue;
        }
        if (!Array.isArray(parsed) || !parsed.length) return null;
        const rows = parsed.map((item) => {
          if (!item || typeof item !== 'object') return null;
          const label = item.label ?? item.name;
          const value = item.value;
          if (typeof label !== 'string' || !label.trim() || value === undefined || value === null) return null;
          if (!['string', 'number', 'boolean'].includes(typeof value)) return null;
          return [label, String(value)];
        });
        return rows.every(Boolean) ? rows : null;
      } catch {
        // Nur die bekannte, doppelt maskierte Importdarstellung erneut versuchen.
        const decoded = normalizeBreaks(candidate).replace(/\\"/g, '"');
        if (decoded === candidate) return null;
        candidate = decoded;
      }
    }
    return null;
  }

  class RichtextProperties extends HTMLElement {
    connectedCallback() {
      if (this.dataset.rendered === 'true') return;
      const content = this.querySelector('[data-richtext-content]');
      if (!content) return;
      this.dataset.rendered = 'true';

      const copy = content.cloneNode(true);
      copy.querySelectorAll('br').forEach((element) => element.replaceWith('\n'));
      copy.querySelectorAll('p, li, h1, h2, h3, h4, h5, h6').forEach((element) => element.append('\n'));
      const rows = readRows(copy.textContent);
      if (rows) {
        const table = document.createElement('table');
        table.className = 'wiepa-richtext-properties__table';
        const body = document.createElement('tbody');
        rows.forEach(([label, value]) => {
          const row = document.createElement('tr');
          const heading = document.createElement('th');
          heading.scope = 'row';
          heading.textContent = normalizeBreaks(label);
          const cell = document.createElement('td');
          cell.textContent = normalizeBreaks(value);
          row.append(heading, cell);
          body.append(row);
        });
        table.append(body);
        content.replaceChildren(table);
        return;
      }

      // Regulären Rich Text unverändert erhalten, nur maskierte Umbrüche normalisieren.
      const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        walker.currentNode.nodeValue = normalizeBreaks(walker.currentNode.nodeValue);
      }
    }
  }
  customElements.define('wiepa-richtext-properties', RichtextProperties);
})();
